import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService, IosDialogService } from '@app/services';
import { CopyOfflineCustomerKeyDialogComponent } from './copy-offline-customer-key-dialog/copy-offline-customer-key-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmDialogComponent } from '../../shared/components/dialogs/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-sso-detached-logged-in',
  templateUrl: './sso-detached-logged-in.component.html',
  styleUrls: ['./sso-detached-logged-in.component.scss'],
})
export class SsoDetachedLoggedInComponent implements OnInit {
  loading: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private dialog: IosDialogService,
    private router: Router,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    const idToken = this.route.snapshot.queryParams?.id_token || this.route.snapshot.fragment.split('id_token=')[1];
    this.doDetachedLogin(idToken);
  }

  private doDetachedLogin(idToken: string): void {
    this.authService
      .detachedLogin(idToken)
      .then(({ offlineCustomerKey, customerName, customerId }) => {
        this.dialog
          .open(CopyOfflineCustomerKeyDialogComponent, {
            header: this.translate.instant('LABELS.OPERATION_COMPLETED_SUCCESSFULLY'),
            width: 'min(450px, 90vw)',
            closable: false,
            closeOnEscape: false,
            data: {
              customerId,
              customerName,
              offlineCustomerKey,
            },
          })
          .onClose.subscribe(() => this.router.navigate(['/']));
      })
      .catch((err) => {
        console.error('An error occurred in /detachedLogin', err);

        const errorCode = err.error?.errorCode;
        this.dialog
          .open(ConfirmDialogComponent, {
            showHeader: false,
            closable: false,
            width: 'min(450px, 90vw)',
            data: {
              title: this.translate.instant('TOAST.ERROR'),
              message: this.translate.instant(errorCode ? `SERV_ERR.${errorCode}` : 'TOAST.GENERAL_ERROR'),
              showPrimaryButton: false,
              secondaryButtonText: this.translate.instant('BUTTONS.OK'),
            },
          })
          .onClose.subscribe(() => this.router.navigate(['/']));
      })
      .finally(() => (this.loading = false));
  }
}
